import { useAuthStore } from '@/stores/authStore.js'

import { myfetch } from '@/connector.js'
import { csrfFetch as fetch } from './csrf.js'


export async function getBuildings(retCall) {
    try {
        const response = await myfetch('/api/user/building', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (response.status != 200)
            return retCall(response.statusText);
        var data = await response.json();


        return retCall(null, data);
    }
    catch (error) {
        return retCall(error.message, null);
    }
}
export async function getDistributionkeys(retCall) {
    try {
        const response = await myfetch('/api/distributionkeys', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (response.status != 200)
            return retCall(response.statusText);
        var data = await response.json();

        return retCall(null, data);
    }
    catch (error) {
        return retCall(error.message, null);
    }
}

export async function getBookingCategories(retCall) {
    try {
        const response = await myfetch('/api/booking/categories', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (response.status != 200)
            return retCall(response.statusText);
        var data = await response.json();

        return retCall(null, data);
    }
    catch (error) {
        return retCall(error.message, null);
    }
}

export async function getBookingStates(retCall) {
    try {
        const response = await myfetch('/api/booking/states', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (response.status != 200)
            return retCall(response.statusText);
        var data = await response.json();

        return retCall(null, data);
    }
    catch (error) {
        return retCall(error.message, null);
    }
}

export async function getBuilding(id, retCall) {
    try {
        const response = await myfetch('/api/building/' + id, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (response.status != 200)
            return retCall(response.statusText);
        var data = await response.json();

        return retCall(null, data);
    }
    catch (error) {
        return retCall(error.message, null);
    }
}


export async function getBuildingUnits(id, retCall) {
    try {
        const response = await myfetch('/api/building/' + id + '/units', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (response.status != 200)
            return retCall(response.statusText);
        var data = await response.json();

        return retCall(null, data);
    }
    catch (error) {
        return retCall(error.message, null);
    }
}

export async function getBookings(retCall, buildingid = 0) {
    var url = '/api/bookings';
    if (buildingid > 0) {
        url += '/building/' + buildingid;
    }
    try {
        const response = await myfetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (response.status != 200)
            return retCall(response.statusText);
        var data = await response.json();


        return retCall(null, data);
    }
    catch (error) {
        return retCall(error.message, null);
    }
}

export async function deleteTransaction(data) {
    const response = await fetch('/api/transactions/delete', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    });

    if (response.status == 200) {
        return true;
    }
    return false;
};

export async function updateTransaction(data) {
    const response = await fetch('/api/transactions/update', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    });

    if (response.status == 200) {
        return true;
    }
    return false;
};

export async function getOperatingCosts(id, retCall) {
    try {
        const response = await myfetch('/api/building/' + id + '/operationcosts', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (response.status != 200)
            return retCall(response.statusText);
        var data = await response.json();

        return retCall(null, data);
    }
    catch (error) {
        return retCall(error.message, null);
    }
}

export async function getOperatingCostsUnit(id, unit, retCall) {
    try {
        const response = await myfetch('/api/building/' + id + '/unit/' + unit + '/operationcosts', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (response.status != 200)
            return retCall(response.statusText);
        var data = await response.json();

        return retCall(null, data);
    }
    catch (error) {
        return retCall(error.message, null);
    }
}

export async function getDashboardInformation(retCall) {
    try {
        const response = await myfetch('/api/dashboard', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (response.status != 200)
            return retCall(response.statusText, null);
        var data = await response.json();

        return retCall(null, data);
    }
    catch (error) {
        return retCall(error.message, null);
    }
}


export async function getBuildingUnitDetails(id, unit) {
    try {
        const response = await myfetch('/api/building/' + id + '/unit/' + unit + '/details', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (await response.status != 200)
            return await response.statusText;
        var data = await response.json();
        return data;
    }
    catch (error) {
        return error.message;
    }
}

export async function getBuildingUnitRentals(id, unit) {
    try {
        const response = await myfetch('/api/building/' + id + '/unit/' + unit + '/rentals', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (await response.status != 200)
            return await response.statusText;
        var data = await response.json();
        return data;
    }
    catch (error) {
        return error.message;
    }
}

export async function getBuildingUnitRentalMonths(id, unit) {
    try {
        const response = await myfetch('/api/building/' + id + '/unit/' + unit + '/rental/months', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (await response.status != 200)
            return await response.statusText;
        var data = await response.json();
        return data;
    }
    catch (error) {
        return error.message;
    }
}


export async function getTenants(retCall) {
    try {
        const response = await myfetch('/api/tenants', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (response.status != 200)
            return retCall(response.statusText);
        var data = await response.json();

        return retCall(null, data);
    }
    catch (error) {
        return retCall(error.message, null);
    }
}

export async function getTenant(id, retCall) {
    try {
        const response = await myfetch('/api/tenant/' + id, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (response.status != 200)
            return retCall(response.statusText);
        var data = await response.json();

        return retCall(null, data);
    }
    catch (error) {
        return retCall(error.message, null);
    }
}


export async function getNavigation(retCall) {
    try {
        const response = await myfetch('/api/layout/navigation', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (response.status != 200)
            return retCall(response.statusText);
        var data = await response.json();


        return retCall(null, data);
    }
    catch (error) {
        return retCall(error.message, null);
    }
}


export async function getTickets(retCall) {
    try {
        const response = await myfetch('/api/tickets', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (response.status != 200)
            return retCall(response.statusText);
        var data = await response.json();


        return retCall(null, data);
    }
    catch (error) {
        return retCall(error.message, null);
    }
}


export async function getTicketContent(ticketid, retCall) {
    try {
        const response = await myfetch('/api/ticket/' + ticketid, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (response.status != 200)
            return retCall(response.statusText);
        var data = await response.json();


        return retCall(null, data);
    }
    catch (error) {
        return retCall(error.message, null);
    }
}

export async function sendTicketMessage(data) {
    const response = await fetch('/api/ticket/message/new', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    });

    if (response.status == 200) {
        return await response.json();
    }
    return false;
};

export async function sendUpdateBuildingAndUnits(buildingid, data) {
    const response = await fetch('/api/building/' + buildingid + '/update', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    });

    if (response.status == 200) {
        return await response.json();
    }
    return false;
};

export async function sendCreateBuildingUnit(buildingid) {
    const response = await fetch('/api/building/' + buildingid + '/units/new', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({})
    });

    if (response.status == 200) {
        return await response.json();
    }
    return false;
};

export async function sendDisableBuildingUnit(buildingid, buildingunitid) {
    const response = await fetch('/api/building/' + buildingid + '/units/' + buildingunitid + '/delete', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({})
    });

    if (response.status == 200) {
        return await response.json();
    }
    return false;
};

export async function uploadBuildingImage(buildingid, data) {
    const response = await fetch('/api/building/' + buildingid + '/image/update', {
        method: 'POST',
        //headers: {
        //    'Accept': 'application/json',
        //    'Content-Type': 'multipart/form-data',
        //},
        body: data
    });

    if (response.status == 200) {
        return await response.json();
    }
    return false;
};

export async function sendFurnishingUpdateBuildingUnit(buildingid, buildingunitid, data) {
    const response = await fetch('/api/building/' + buildingid + '/units/' + buildingunitid + '/furnish/update', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    });

    if (response.status == 200) {
        return await response.json();
    }
    return false;
};

export async function sendCreateBuilding() {
    const response = await fetch('/api/building/new', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({})
    });

    if (response.status == 200) {
        return await response.json();
    }
    return false;
};

export async function sendDisableBuilding(buildingid) {
    const response = await fetch('/api/building/' + buildingid + '/delete', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({})
    });

    if (response.status == 200) {
        return await response.json();
    }
    return false;
};

export async function sendUpdateBankAccount(id) {
    const response = await fetch('/api/bank/update/' + id, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({})
    });

    if (response.status == 200) {
        return await response.json();
    }
    return false;
}

export async function sendAddBankAccount(data) {
    const response = await fetch('/api/bank/add', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    });

    if (response.status == 200) {
        return await response.json();
    }
    return false;
}
export async function sendAddBankAccountInput(data) {
    const response = await fetch('/api/bank/add/input', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    });

    if (response.status == 200) {
        return await response.json();
    }
    return false;
}

export async function sendAddBankAccountStatus(responseitem, retCall) {
    try {
        const response = await myfetch('/api/bank/status/' + responseitem, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (response.status != 200)
            return retCall(response.statusText);
        var data = await response.json();

        return retCall(null, data);
    }
    catch (error) {
        return retCall(error.message, null);
    }
}

export async function getBankOptions(retCall) {
    var url = '/api/bank/options';
    try {
        const response = await myfetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (response.status != 200)
            return retCall(response.statusText);
        var data = await response.json();

        return retCall(null, data);
    }
    catch (error) {
        return retCall(error.message, null);
    }
}

export async function getBankAccounts(retCall) {
    var url = '/api/bank/accounts/get';
    try {
        const response = await myfetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (response.status != 200)
            return retCall(response.statusText);
        var data = await response.json();

        return retCall(null, data);
    }
    catch (error) {
        return retCall(error.message, null);
    }
}

export async function updateCategory(data) {
    const response = await fetch('/api/transactions/category/update', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    });

    if (response.status == 200) {
        return true;
    }
    return false;
};

export async function getBuildingDocuments(buildingid, retCall) {
    var url = '/api/building/' + buildingid + '/documents';
    try {
        const response = await myfetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (response.status != 200)
            return retCall(response.statusText);
        var data = await response.json();


        return retCall(null, data);
    }
    catch (error) {
        return retCall(error.message, null);
    }
}

export async function getBuildingDocument(buildingid, documentid, retCall) {
    var url = '/api/building/' + buildingid + '/document/' + documentid;
    try {
        const response = await myfetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (response.status != 200)
            return retCall(response.statusText);
        var data = await response.json();

        return data;
    }
    catch (error) {
        return false;
    }
}

export async function uploadBuildingDocument(buildingid, data) {
    const response = await fetch('/api/building/' + buildingid + '/document/upload', {
        method: 'POST',
        //headers: {
        //    'Accept': 'application/json',
        //    'Content-Type': 'multipart/form-data',
        //},
        body: data
    });

    if (response.status == 200) {
        return await response.json();
    }
    return false;
};

export async function updateBuildingDocument(buildingid, iddocument, data) {
    const response = await fetch('/api/building/' + buildingid + '/document/' + iddocument + '/update', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    });

    if (response.status == 200) {
        return true;
    }
    return false;
}


export async function sendAddNewContact(data) {
    const response = await fetch('/api/user/create', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    });

    if (response.status == 200) {
        return true;
    }
    return false;
}

export async function sendTenantUpdateBuildingUnit(buildingid, buildingunitid, data) {
    const response = await fetch('/api/building/' + buildingid + '/unit/' + buildingunitid + '/tenant/update', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    });

    if (response.status == 200) {
        return true;
    }
    return false;
};

export async function getTaxInfo(id, year, retCall) {
    try {
        const response = await myfetch('/api/building/' + id + '/taxinfo/' + year, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (response.status != 200)
            return retCall(response.statusText);
        var data = await response.json();

        return retCall(null, data);
    }
    catch (error) {
        return retCall(error.message, null);
    }
}

export async function sendUpdateFinances() {
    const response = await myfetch('/api/bank/finances/update', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({})
    });

    if (response.status == 200) {
        return await response.json();
    }
    return false;
}


export async function getOpenRentsByBuilding(idbuilding, retCall) {
    try {
        const response = await myfetch('/api/building/' + idbuilding + '/rents/open', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (response.status != 200)
            return retCall(response.statusText);
        var data = await response.json();


        return retCall(null, data);
    }
    catch (error) {
        return retCall(error.message, null);
    }
}

export async function getReceivedRentals(buildingId) {
    const response = await myfetch(
        `/api/building/${encodeURIComponent(buildingId)}/received-rentals`,
        {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        }
    )

    if (response.status === 200) {
        return await response.json()
    }

    return false
}

export async function deleteReceivedRental(buildingId, idreceivedRental) {
    const response = await fetch(
        `/api/building/${encodeURIComponent(buildingId)}/received-rentals/delete`,
        {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                idreceived_rental: idreceivedRental
            })
        }
    )

    if (response.status === 200) {
        return await response.json()
    }

    if (response.status === 204) {
        return true
    }

    return false
}
